import { Box } from "@mui/material";
import {
  PTCheckbox,
  PTTranslate,
  PTTypography,
} from "../../../../common/components/ui";
import { useLanguage } from "../../../../common/hooks";
import config from "../../../../config";

const RegleGestionComponent = () => {
  const { currentLang } = useLanguage();
  const policyText = (
    <Box sx={{ ml: 0.5 }}>
      <PTTypography
        variant="body2"
        color="text.secondary"
        sx={{ fontSize: "0.875rem", lineHeight: 1.5 }}
      >
        <Box component="span" sx={{ display: "block" }}>
          <PTTranslate tk="policy.dataCollection" />{" "}
          <PTTranslate tk="policy.cndpDeclaration" />
          {` ${config.cndpNumber}.`}
          <br />
          <PTTranslate tk="policy.contactRights" />{" "}
          <a href="mailto:deontologie@portnet.ma">deontologie@portnet.ma</a>{" "}
          <PTTranslate tk="policy.accessRights" />
        </Box>
        <Box component="span" sx={{ display: "block", mt: 0.5 }}>
          <PTTranslate tk="policy.acceptTerms" />{" "}
          <a href="#" underline="hover">
            <PTTranslate tk="policy.termsOfUse" />
          </a>
        </Box>
      </PTTypography>
    </Box>
  );

  return (
    <Box
      sx={{
        ...(currentLang !== "ar" ? { ml: 1.5 } : { ml: 1.5 }),
        ...(currentLang === "ar" ? { mr: "-20px" } : {}),
        mt: 1,
        mb: 2,
      }}
    >
      <PTCheckbox
        name="acceptPolicy"
        required
        label={policyText}
        lg={12}
        md={12}
      />
    </Box>
  );
};

export default RegleGestionComponent;
